










import { Vue, Component, Prop } from 'vue-property-decorator';
import {State} from "vuex-class";
import {makeArabic} from "@/components/Functions/Functions";

@Component({})
export default class PageInfo extends Vue {
    @Prop({default: []}) routes: string[];
    @Prop({default: ''}) adminUser: string;
    @State language: any;
    arabic(user: string): string {
        if (user.toLowerCase() !== 'user')
            return user;
        return 'المستخدم';
    }

    arabicRoute(route: string): string {
        return makeArabic(route);
    }
}
